<!--
    描述：专家认证 -- 信息页面
    时间：2022-4-27 09:56:13
    Created by 钱磊
-->
<template>
	<div class="expert-info-main" ref="scrollContainer">
		<!-- <div class="header-note">
			注：专家本人须承诺提交至平台的信息真实可靠，否则会承担相应法律责任
		</div> -->
		<el-collapse v-model="activeNames">
			<el-collapse-item title="本次申请加入专家库" name="1" v-if="!isBase">
				<div class="pdl10 pdr10 mt10">
					<vxe-table
						align="center"
						border
						auto-resize
						resizable
						:data="libDetailsData"
						show-header-overflow="tooltip"
						show-overflow="tooltip"
						show-footer-overflow="tooltip"
					>
						<vxe-table-column type="seq" title="序号" align="center" width="70"></vxe-table-column>
						<vxe-table-column title="专家库名称" field="sname" width="200"></vxe-table-column>
						<vxe-table-column title="专业类别" field="specialtyName" min-width="300">
							<template v-slot="{ row }">
								{{ row.specialtyName | specialChange }}
							</template>
						</vxe-table-column>
						<vxe-table-column title="服务范围" field="reviewAreaName" min-width="300">
							<template v-slot="{ row }">
								{{ row.reviewAreaName | specialChange }}
							</template>
						</vxe-table-column>
						<vxe-table-column title="主要参评经验" field="projectExp" min-width="300"></vxe-table-column>
						<vxe-table-column title="规则说明" field="remark" width="80">
							<template v-slot="{ row }">
								<el-button type="text" size="small" @click="handleCheck(row)">查看 </el-button>
							</template>
						</vxe-table-column>
					</vxe-table>
				</div>
			</el-collapse-item>
			<el-collapse-item title="已加入专家库" name="2" v-if="!isBase">
				<div class="pdl10 pdr10 mt10">
					<vxe-table
						align="center"
						border
						auto-resize
						:data="joinLibList"
						show-header-overflow="tooltip"
						show-overflow="tooltip"
						show-footer-overflow="tooltip"
					>
						<vxe-table-column type="seq" title="序号" align="center" width="70"></vxe-table-column>
						<vxe-table-column title="专家库名称" field="sname"></vxe-table-column>
						<vxe-table-column title="专业类别">
							<template v-slot="{ row }">
								{{ row.specialtyName | specialChange }}
							</template>
						</vxe-table-column>
						<vxe-table-column title="服务范围">
							<template v-slot="{ row }">
								{{ row.areaName | specialChange }}
							</template>
						</vxe-table-column>
						<vxe-table-column title="主要参评经验" field="projectExp"></vxe-table-column>
						<vxe-table-column title="审核人" field="updateUser"></vxe-table-column>
						<vxe-table-column title="审核时间" field="updateDate"></vxe-table-column>
					</vxe-table>
				</div>
			</el-collapse-item>
			<el-collapse-item title="基础信息" name="3" class="por">
				<div class="expert-content" :class="{ h100: routeQuery == 'checkZj' }">
					<el-form :model="personForm" label-width="170px" size="small" ref="personForm" :show-message="false">
						<el-row>
							<el-col :span="11">
								<el-form-item label="姓名：">
									{{ personForm.sname ? personForm.sname : '' }}
								</el-form-item>
							</el-col>
							<el-col :span="11" :offset="1">
								<el-form-item label="性别：">
									{{ personForm.sex == '1' ? '男' : '女' }}
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="11">
								<el-form-item label="证件类型：">
									{{ personForm.cardTypeName ? personForm.cardTypeName : '' }}
								</el-form-item>
							</el-col>
							<el-col :span="11" :offset="1">
								<el-form-item label="证件号码：">
									{{ personForm.cardType == '1002048001' ? personForm.idCard : personForm.otherNo }}
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item label="手机号：">
									{{ personForm.phone ? personForm.phone : '' }}
								</el-form-item>
							</el-col>
							<el-col :span="11" :offset="1">
								<el-form-item label="年龄：">
									{{ personForm.ages ? personForm.ages : '' }}
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="11">
								<el-form-item label="毕业院校：">
									{{ personForm.academy ? personForm.academy : '' }}
								</el-form-item>
							</el-col>
							<el-col :span="11" :offset="1">
								<el-form-item label="工作开始年份：" prop="proYears">
									{{ personForm.proYears ? personForm.proYears : '' }}年
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="11">
								<el-form-item label="所属地区：" prop="addressObj">
									{{ personForm.areaName ? personForm.areaName : '' }}
								</el-form-item>
							</el-col>
							<el-col :span="11" :offset="1">
								<el-form-item label="最高学历：" prop="email">
									{{ personForm.educationName ? personForm.educationName : '' }}
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item label="现工作单位：">
									{{ personForm.unitName ? personForm.unitName : '' }}
								</el-form-item>
							</el-col>
							<el-col :span="11" :offset="1">
								<el-form-item label="邮箱：" prop="email">
									{{ personForm.email ? personForm.email : '' }}
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item label="职务：" prop="post">
									{{ personForm.post ? personForm.post : '' }}
								</el-form-item>
							</el-col>
							<el-col :span="11" :offset="1">
								<el-form-item label="部门：" prop="department">
									{{ personForm.department ? personForm.department : '' }}
								</el-form-item>
							</el-col>
							<el-col :span="23">
								<el-form-item label="规避单位：" :show-message="false">
									{{ personForm.evadeNames ? personForm.evadeNames : '' }}
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="11">
								<el-form-item label="个人一寸照片：" required>
									<div class="upload-item">
										<public-upload
											ref="yc_pic"
											isViewMode
											:viewFilesList="chioseFile('yc_pic')"
											listType="picture-card"
										></public-upload>
									</div>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="24">
								<el-form-item label="证件照片：" required>
									<div class="flex">
										<div class="upload-item1">
											<public-upload
												ref="idcard_1"
												isViewMode
												:viewFilesList="chioseFile('idcard_1')"
												listType="picture-card"
											></public-upload>
											<div class="top-item-text2">身份证人像面</div>
										</div>
										<div class="upload-item1">
											<public-upload
												ref="idcard_2"
												isViewMode
												:viewFilesList="chioseFile('idcard_2')"
												listType="picture-card"
											></public-upload>
											<div class="top-item-text2">身份证国徽面</div>
										</div>
									</div>
								</el-form-item>
							</el-col>
						</el-row>
						<!-- 省级及以上专家聘书列表 -->
						<div class="file-row">
							<el-row v-for="(item, index) in zjpsList" :key="'聘书' + index">
								<el-col :span="7">
									<el-form-item label="省级及以上专家聘书：">
										<div class="upload-item">
											<public-upload
												:ref="`eduction${index}`"
												:viewFilesList="item.files ? item.files : []"
												isViewMode
												listType="picture-card"
											></public-upload>
										</div>
									</el-form-item>
								</el-col>
								<el-col :span="15">
									<el-row>
										<el-col :span="10">
											<el-form-item label="颁发单位：">
												{{ item.issueUnit && item.issueUnit != 'null' ? item.issueUnit : '' }}
											</el-form-item>
										</el-col>
										<el-col :span="7">
											<el-form-item label="颁发时间：">
												{{ item.issueDate | timeFilter }}
											</el-form-item>
										</el-col>
										<el-col :span="7">
											<el-form-item label="有效期至：">
												{{ item.dueDate | timeFilter }}
											</el-form-item>
										</el-col>
									</el-row>
								</el-col>
							</el-row>
						</div>
						<!-- 学历列表 -->
						<div class="file-row">
							<el-row v-for="(item, index) in eductionList" :key="'学历' + index">
								<el-col :span="7">
									<el-form-item label="学历证书：">
										<div class="upload-item">
											<public-upload
												:ref="`eduction${index}`"
												:viewFilesList="item.files ? item.files : []"
												isViewMode
												listType="picture-card"
											></public-upload>
										</div>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="学历：">
										{{ item.educationName && item.educationName != 'null' ? item.educationName : '' }}
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="专业：">
										{{ item.profession && item.profession != 'null' ? item.profession : '' }}
									</el-form-item>
								</el-col>
							</el-row>
						</div>
						<!-- 职称列表 -->
						<div class="file-row">
							<el-row v-for="(item, index) in careerList" :key="'职称' + index">
								<el-col :span="7">
									<el-form-item label="职称证书：">
										<div class="upload-item">
											<public-upload
												:ref="`career${index}`"
												:viewFilesList="item.files ? item.files : []"
												isViewMode
												listType="picture-card"
											></public-upload>
										</div>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="职称：">
										{{ item.certificateGradeName && item.certificateGradeName != 'null' ? item.certificateGradeName : '' }}
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="职称专业：">
										{{ item.qualified && item.qualified != 'null' ? item.qualified : '' }}
									</el-form-item>
								</el-col>
							</el-row>
						</div>
						<!-- 执业资格列表 -->
						<div class="file-row">
							<el-row v-for="(item, index) in licenseList" :key="'执业资格' + index">
								<el-col :span="7">
									<el-form-item label="执业资格证书：">
										<div class="upload-item">
											<public-upload
												:ref="`license${index}`"
												:viewFilesList="item.files ? item.files : []"
												isViewMode
												listType="picture-card"
											></public-upload>
										</div>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="执业资格：">
										{{ item.typeName && item.typeName != 'null' ? item.typeName : '' }}
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="登记专业：">
										{{ item.professionName && item.professionName != 'null' ? item.professionName : '' }}
									</el-form-item>
								</el-col>
							</el-row>
						</div>
						<!-- 其它证书列表 -->
						<div class="file-row">
							<el-row v-for="(item, index) in otherList" :key="'其它证书' + index">
								<el-col :span="7">
									<el-form-item label="其它证书：">
										<div class="upload-item">
											<public-upload
												:ref="`other${index}`"
												:viewFilesList="item.files ? item.files : []"
												isViewMode
												listType="picture-card"
											></public-upload>
										</div>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="证书名称：">
										{{ item.certificateName && item.certificateName != 'null' ? item.certificateName : '' }}
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="发证单位：">
										{{ item.issueUnit && item.issueUnit != 'null' ? item.issueUnit : '' }}
									</el-form-item>
								</el-col>
							</el-row>
						</div>
						<el-row>
							<el-col :span="23">
								<el-form-item label="个人履历介绍：">
									{{ personForm.intro && personForm.intro != 'null' ? personForm.intro : '' }}
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>
				<!--加入平台库-->
				<div v-if="rowData.busType == '1002049001' || rowData.busType == '1002049022'" class="boxs-top">
					<span v-if="isPc == '1'"><svg-icon class="laiyuan-icon" icon-class="PC"></svg-icon></span>
					<span v-if="isPc == '0'"><svg-icon class="laiyuan-icon" icon-class="xcx"></svg-icon></span>
				</div>
			</el-collapse-item>
			<el-collapse-item title="审核记录" name="4" v-if="routerMode == 'view'">
				<div class="pdl10 pdr10 mt10">
					<vxe-table align="center" border auto-resize :data="checkData" show-header-overflow="tooltip" show-footer-overflow="tooltip">
						<vxe-table-column title="审核结果" field="status">
							<template #default="{ row }">
								<span v-if="row.status == 0">待审核</span>
								<span v-else-if="row.status == 1">审核通过</span>
								<span v-else-if="row.status == 2">驳回</span>
							</template>
						</vxe-table-column>
						<vxe-table-column title="审核人" field="upUserSname"></vxe-table-column>
						<vxe-table-column title="审核时间" field="updateDate"></vxe-table-column>
						<vxe-table-column title="审核意见" field="remark"></vxe-table-column>
					</vxe-table>
				</div>
			</el-collapse-item>
		</el-collapse>
		<div class="footer text-right">
			<el-button size="mini" icon="el-icon-edit-outline" v-if="isZjChcek && !routerMode" @click="auditSubmit">审核</el-button>
		</div>
		<el-dialog title="入库标准" :visible.sync="checkDialog" width="800px" :close-on-click-modal="false" center>
			<div v-html="applyStandard"></div>
		</el-dialog>
	</div>
</template>

<script>
import { getRecordDetail } from 'api/modules/audit'
import * as ExpertApi from '@/api/modules/expert'
import { getAgeById } from 'utils/tools'
import { mapState } from 'vuex'

import addressForm from '@/views/operation-management/expert/addressForm'

export default {
	name: '',
	components: {
		addressForm
	},
	props: {
		rowData: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	filters: {
		specialChange(val) {
			if (val) {
				let values = val.replace(/,/g, '/')
				return values
			} else {
				return '-'
			}
		},
		timeFilter(val) {
			if (val) {
				return val.split(' ')[0]
			}
		}
	},
	data() {
		return {
			activeNames: ['1', '2', '3', '4'], //展开列集合
			personForm: {},
			checkData: [], // 审核记录
			libDetailsData: [], //本次申请加入专家库
			joinLibList: [], //已加入专家库
			zjpsList: [{}], // 省级及以上专家聘书列表
			eductionList: [{}], // 学历列表
			careerList: [{}], // 职称列表
			licenseList: [{}], // 职业资格列表
			otherList: [{}], // 其它证书列表
			allFiles: [], //所有附件
			viewFilesList: [], //图片的数据
			checkDialog: false, //查看入库标准
			applyStandard: '', //入库标准内容
			scrollTop: 0,
			isPc: ''
		}
	},
	created() {
		if (!this.rowData.createUserid) {
			this.$router.push({
				name: 'Audit-affairs-new'
			})
			return
		}
		// 获取全部基本信息
		this.getAllInfo()
	},
	mounted() {
		const box = document.querySelector('.main-page-container')
		box.addEventListener('scroll', this.handleScroll)
	},
	beforeDestroy() {
		const box = document.querySelector('.main-page-container')
		box.removeEventListener('scroll', this.handleScroll)
	},
	methods: {
		handleScroll(e) {
			if (e) {
				const box = document.querySelector('.boxs-top')
				box.style.top = `${70 + e.target.scrollTop}px`
			}
		},

		// 初始回显信息
		getAllInfo() {
			getRecordDetail({ recordId: this.rowData.id, id: this.rowData.id })
				.then((res) => {
					this.isPc = res.data && res.data.hasOwnProperty('isPc') && res.data.isPc === 0 ? '0' : '1'
					this.personForm = Object.assign({}, res.data.baseInfo)
					// 个人信息的图片
					this.viewFilesList = res.data.baseInfo.baseFiles
					// 省级及以上专家聘书列表
					this.zjpsList = res.data.expertOffer
					// 学历证书
					this.eductionList = res.data.educations
					// 职称证书
					this.careerList = res.data.practices

					// 执业资格证书
					this.licenseList = res.data.certificates

					// 其他证书
					this.otherList = res.data.otherCertificates

					// 本次申请加入专家库
					this.libDetailsData = res.data.libDetails
					//已加入专家库
					this.joinLibList = res.data.joindeLibs
					if (this.routerMode == 'view') {
						// 审核记录 -- 2025-09-19 替换以前的单独接口
						this.checkData = res.data.applyRecords || []
					}
				})
				.catch((err) => {})
		},
		// 判断图片类型
		chioseFile(Type) {
			let data = []
			switch (Type) {
				case 'yc_pic':
					data = this.viewFilesList.filter((x) => x.assortment == 'yc_pic')
					break
				case 'zjzs':
					data = this.viewFilesList.filter((x) => x.assortment == 'zjzs')
					break
				case 'idcard_1':
					data = this.viewFilesList.filter((x) => x.assortment == 'idcard_1')
					break
				case 'idcard_2':
					data = this.viewFilesList.filter((x) => x.assortment == 'idcard_2')
					break
				case 'idcard_3':
					data = this.viewFilesList.filter((x) => x.assortment == 'idcard_3')
					break
				case 'cns':
					data = this.viewFilesList.filter((x) => x.assortment == 'cns')
					break
			}
			return data
		},
		// 专家审核提交审核
		auditSubmit() {
			let params = {
				id: this.rowData.id,
				busId: this.rowData.busId,
				busType: this.rowData.busType,
				libId: this.libDetailsData[0].libId,
				libName: this.libDetailsData[0].sname,
				isPb: this.libDetailsData[0].isPb,
				expertName: this.personForm.sname,
				expertPhone: this.personForm.phone
			}
			this.$emit('openDia', params)
		},
		handleCheck(row) {
			this.applyStandard = row.applyStandard
			this.checkDialog = true
		}
	},
	computed: {
		...mapState('user', {
			userInfo: (state) => state.userInfo
		}),

		isZjChcek() {
			return this.$route.query.type == 'checkZj'
		},
		routeQuery() {
			return this.$route.query.type
		},

		routerMode() {
			return this.$route.query.mode
		},
		//是否是基础库
		isBase() {
			return this.$route.query.isBase
		}
	},
	watch: {
		'personForm.idCard'() {
			this.personForm.age = this.personForm.idCard ? getAgeById(this.personForm.idCard) : ''
		},
		scrollTop(newVal) {
			console.log('变化', newVal)
		}
	}
}
</script>

<style scoped lang="less">
.expert-info-main {
	height: 100%;
	.header-note {
		height: 34px;
		line-height: 34px;
		padding: 0 13px;
		border: 1px solid #fbcdd1;
		font-size: 12px;
		color: #e60012;
		background: #fde6e6;
		margin-bottom: 13px;
	}

	.expert-content {
		background-color: #fff;
		padding: 20px;
		height: calc(~'100% - 48px - 20px');
		overflow-y: auto;
	}

	.file-row {
		background-color: #fafbfe;
		padding: 15px 0 0;
		margin-bottom: 15px;
	}

	.el-checkbox {
		margin-right: 24px !important;
	}

	.btn-tools {
		position: absolute;
		right: 30px;
		top: 10px;
		z-index: 10;

		.btn-icons {
			display: block;
			width: 40px;
			line-height: 40px;
			height: 40px;
			text-align: center;
			font-size: 20px;
			color: #fff;
			cursor: pointer;
		}

		.red-bg {
			background-color: #f44336;
		}

		.blue-bg {
			background-color: #409eff;
		}
	}

	.menu-block {
		height: 40px;
		line-height: 40px;
		background-color: #fafbfe;
		padding: 0 20px;
		font-size: 14px;
		color: #202020;
		margin-bottom: 10px;

		.text-color {
			font-size: 12px;
			color: #e60012;
			margin-left: 20px;
		}
	}
	.h100 {
		height: 100% !important;
	}
	.download-btn {
		vertical-align: bottom;
		margin-bottom: 18px;
		margin-left: 10px;
	}
}
.upload-item {
	width: 220px;
	height: 120px;
}
.upload-item1 {
	width: 220px;
}
.top-item-text2 {
	font-size: 12px;
	line-height: 30px;
	color: #666;
	text-align: center;
}
.footer {
	position: absolute;
	top: 88px;
	right: 135px;
	.el-button {
		height: 28px !important;
	}
}
.asq {
	/deep/ .el-cascader-menu__wrap {
		height: 340px;
	}
}
/deep/.el-collapse-item__header {
	font-size: 14px !important;
	font-weight: 600 !important;
	padding-left: 30px !important;
	background-color: #eff6fe !important;
	margin-top: 5px;
	height: 36px;
	line-height: 36px;
}
.por {
	position: relative;
}
.boxs-top {
	position: absolute;
	top: 70px;
	right: 30px;
}
.laiyuan-icon {
	font-size: 50px;
}
</style>
